export const settingsKeyMap = {
    file_path: 'filePath',
    file_id: 'fileId',
};

export const initialSettingsMap = {
    filePath: 'file_path',
    fileId: 'file_id',
};
